import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import * as actionsInventory from '../../../../actions/inventoryAction';
import ListItemInventory from './ListItemInventoryGeneral';
import InventoryService from '../../../../services/InventoryService';
import { ENUMS } from '../../../../utils/constants';
import ListPagination from '../../../../components/UI/ListPaginationUl';

const ListInventoryGeneral = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [, setEventRouteClick] = useState({});
    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.inventories?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData(props.inventories.items);
            } else {
                setData((prevState) => ([...prevState, ...props.inventories.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [props?.inventories?.items]);

    useEffect(() => {
        const loadInventory = () => {
            props.getInventories(props.user.vision, props.location?.state.typeInventory, {
                PageSize: ENUMS.ePagination.PageSize.value,
                PageIndex: currentPage
            });
        };
        loadInventory();
        // eslint-disable-next-line
    }, [currentPage]);

    const onSelectItemChange = (event, item) => {
        props.selectInventory(item);
        props.getBalaceData(item.id);
        setEventRouteClick(event.currentTarget.pathname);
    };

    const onRefreshInventory = (event, item) => {
        props.selectInventory(item);
        props.getBalaceData(item.id);
        props.filter.lotNumber = 0;
        props.refreshLots(props.filter, false);
    };

    return props.inventories && props.inventories.items ? (
        <div id="listInventories">
            <ListPagination
                page={props.inventories?.totalPages}
                current={{ currentPage, setCurrentPage }}
                data={
                    data.map((item, index) => {
                        return (
                            <ListItemInventory
                                // eslint-disable-next-line react/no-array-index-key
                                key={`oi-${index}`}
                                route="./"
                                data={item}
                                onSelectChange={(event) => onSelectItemChange(event, item)}
                                onRefreshInventory={(event) => onRefreshInventory(event, item)}
                            />
                        );
                    })
                }
            />
        </div>
    ) : null;
};

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter,
        inventories: state.inventoryReducer.inventoryList,
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getInventories: (vision, typeInventory, pagination) => {
            dispatch(InventoryService.getInventories(vision, typeInventory, pagination));
        },
        selectInventory: (inventory) => {
            dispatch(actionsInventory.selectInventory(inventory));
        },
        changeUserLots: (inventory) => {
            dispatch(actionsInventory.changeUserLots(inventory));
        },
        refreshLots: (filter, showLoading) => {
            dispatch(InventoryService.refreshLots(filter, showLoading));
        },
        getBalaceData: (filter, callback) => {
            dispatch(InventoryService.getBalaceData(filter, callback));
        },

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListInventoryGeneral)));
